import { useEffect } from 'react';
import { useTheme } from 'chat-interface-lib';

/**
 * Hook that syncs theme changes from chat-interface-lib to multi-agent-chat DOM classes
 * This ensures that when the theme changes in chat-interface-lib, the multi-agent-chat
 * interface reflects the same theme state for proper CSS isolation
 */
export function useMultiAgentThemeSync() {
  const { theme } = useTheme();

  useEffect(() => {
    // Find the multi-agent-chat root element
    const rootElement = document.querySelector('.multi-agent-chat-root');
    
    if (rootElement) {
      // Remove existing theme classes
      rootElement.classList.remove('light', 'dark');
      
      // Add the current theme class
      rootElement.classList.add(theme);
      
      // Also add the theme class to the document element for broader CSS variable access
      // but only when we're within the multi-agent-chat context
      if (document.documentElement.classList.contains('multi-agent-chat-context')) {
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
      }
    }
  }, [theme]);

  return { theme };
} 